import React, { useEffect, useRef } from "react";

function playRingtone(audioCtxRef, gainRef) {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    audioCtxRef.current = ctx;
    const gain = ctx.createGain();
    gain.gain.value = 0.3;
    gain.connect(ctx.destination);
    gainRef.current = gain;

    function ring() {
      if (!audioCtxRef.current) return;
      // Two-tone ring pattern (like a phone)
      const now = ctx.currentTime;
      const tones = [
        { freq: 440, start: 0, end: 0.4 },
        { freq: 480, start: 0, end: 0.4 },
        { freq: 440, start: 0.6, end: 1.0 },
        { freq: 480, start: 0.6, end: 1.0 },
      ];
      tones.forEach(({ freq, start, end }) => {
        const osc = ctx.createOscillator();
        osc.type = "sine";
        osc.frequency.value = freq;
        const env = ctx.createGain();
        env.gain.setValueAtTime(0, now + start);
        env.gain.linearRampToValueAtTime(0.15, now + start + 0.05);
        env.gain.setValueAtTime(0.15, now + end - 0.05);
        env.gain.linearRampToValueAtTime(0, now + end);
        osc.connect(env);
        env.connect(gain);
        osc.start(now + start);
        osc.stop(now + end);
      });
      // Repeat every 2 seconds
      audioCtxRef.current._ringTimer = setTimeout(ring, 2000);
    }
    ring();
  } catch {
    // Audio API not available
  }
}

function stopRingtone(audioCtxRef) {
  if (audioCtxRef.current) {
    clearTimeout(audioCtxRef.current._ringTimer);
    audioCtxRef.current.close().catch(() => {});
    audioCtxRef.current = null;
  }
}

export default function IncomingCallOverlay({ callerUsername, callType = "video", onAccept, onReject }) {
  const audioCtxRef = useRef(null);
  const gainRef = useRef(null);

  useEffect(() => {
    playRingtone(audioCtxRef, gainRef);
    return () => stopRingtone(audioCtxRef);
  }, []);

  const handleAccept = () => {
    stopRingtone(audioCtxRef);
    onAccept();
  };

  const handleReject = () => {
    stopRingtone(audioCtxRef);
    onReject();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.7)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "#1e1e2e",
          borderRadius: 20,
          padding: "2.5rem 2rem",
          textAlign: "center",
          minWidth: 280,
          border: "1px solid rgba(185,151,255,0.3)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ marginBottom: 16 }}>
          <ion-icon
            name="call"
            style={{
              fontSize: "3rem",
              color: "#b997ff",
              animation: "ring 1.5s ease-in-out infinite",
            }}
          ></ion-icon>
        </div>
        <h3 style={{ color: "#fff", margin: "0 0 8px", fontSize: "1.4rem" }}>
          {callerUsername}
        </h3>
        <p style={{ color: "#aaa", fontSize: "0.9rem", margin: "0 0 24px" }}>
          Incoming {callType === "audio" ? "audio" : "video"} call...
        </p>
        <div style={{ display: "flex", gap: 16, justifyContent: "center" }}>
          <button
            onClick={handleReject}
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              border: "none",
              backgroundColor: "#ff4444",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ion-icon
              name="call"
              style={{ color: "#fff", fontSize: "1.6rem", transform: "rotate(135deg)" }}
            ></ion-icon>
          </button>
          <button
            onClick={handleAccept}
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              border: "none",
              backgroundColor: "#4CAF50",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ion-icon
              name="call"
              style={{ color: "#fff", fontSize: "1.6rem" }}
            ></ion-icon>
          </button>
        </div>
        <style>{`
          @keyframes ring {
            0%, 100% { transform: rotate(0deg); }
            10% { transform: rotate(15deg); }
            20% { transform: rotate(-15deg); }
            30% { transform: rotate(10deg); }
            40% { transform: rotate(-10deg); }
            50% { transform: rotate(0deg); }
          }
        `}</style>
      </div>
    </div>
  );
}
